import { withCompanyName } from '@routes/-withCompanyName'
import { createFileRoute, redirect } from '@tanstack/react-router'

export const Route = createFileRoute('/_unauthenticated/reset/$id')({
  head: () => ({
    meta: [
      {
        title: withCompanyName('Forgot Password'),
      },
    ],
  }),
  beforeLoad: async (context) => {
    throw redirect({
      to: '/reset_confirm',
      state: (oldState) => ({ ...oldState, id: context?.params?.id }),
      replace: true,
    })
  },
})
